export const coursesManagement = {
  name: "Course Management |||| Course Management",
  fields: {
    title: "Course Name",
    isEnabled: "Distributed",
    order: "Order",
    courseGroupsIds: "Groups",
    externalCourseId: "Moodle ID",
    groupsCount: "Groups Count",
  },
};

export const myCourses = {
  name: "My Courses |||| My Courses",
  fields: {
    id: "ID",
    title: "Course Name",
  },
  buttons: {
    access: "Access Course",
  },
  messages: {
    courseNotFound: "Course not found",
    accessError: "Error accessing course",
  },
};
